import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilityService } from '../../services/utility.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatSort } from '@angular/material';

export interface PeriodicElement {
  name: string;
  achievemet: string;
  expiry: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { name: 'Alex Padely', achievemet: '20/10/2020', expiry: '12/08/1920' },
  { name: 'Brogan Stallard', achievemet: '20/10/2020', expiry: '12/08/1920' },
  { name: 'Christopher Field', achievemet: '20/10/2020', expiry: '12/08/1920' },
  { name: 'Leam Brennan', achievemet: '20/10/2020', expiry: '12/08/1920' },
  { name: 'Samantha Dalling', achievemet: '20/10/2020', expiry: '12/08/1920' },
];

@Component({
  selector: 'app-competency-detail-modal',
  templateUrl: './competency-detail-modal.component.html',
  styleUrls: ['./competency-detail-modal.component.scss']
})
export class CompetencyDetailModalComponent implements OnInit {

  displayedColumns: string[] = ['name', 'achievemet', 'expiry'];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  competencyData
  monthsCount
  competenciesData
  systemDate
  userList : Boolean = false
  category = []
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: false }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(public _utilityService: UtilityService, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<CompetencyDetailModalComponent>) { 
    this.dataSource = new MatTableDataSource();

  }
 

  ngOnInit() {
    console.log("DETAIL LIST", this.data)
    this.competenciesData = this.data.competencies
    this.systemDate=this.data.systemDate
    this.userList = this.data.userList
    this.category = this.data.categoryList
    console.log("here comp data check details model==>",this.competenciesData)

    // // this.monthsCount = (this.competencyData.expiryDate.getFullYear() - this.competencyData.achievementDate.getFullYear()) * 12 + (this.competencyData.expiryDate.getMonth() - this.competencyData.achievementDate.getMonth())
    // this.monthsCount = (new Date(this.competencyData.expiryDate).getFullYear() - new Date(this.competencyData.achievementDate).getFullYear()) * 12;
    // this.monthsCount -= new Date(this.competencyData.achievementDate).getMonth() + 1;
    // this.monthsCount += new Date(this.competencyData.expiryDate).getMonth() + 1; // we should add + 1 to get correct month number
    // this.monthsCount <= 0 ? 0 : this.monthsCount;
    // console.log("hello here is model details===>", this.data)
    // this.updateData(this.data.user)
  }
  // getRandomColorClass(i) {
  //   return this._utilityService.getCommonRandomColorClass(i)



  // }

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;

  // }


  // updateData(user) {
  //   console.log("UPDATING DATA = ", user)
  //   this.dataSource = new MatTableDataSource(user);
  //   this.dataSource.sortingDataAccessor = (item, property) => {
  //     console.log("item=====>>>>>", item);
  //     console.log("property=====>>>>>", property);

  //     switch (property) {
  //       case 'name': return item.name;
  //       case 'achievemet':
  //         return item.competencyDetails.achievementDate;
  //       case 'expiry': return item.competencyDetails.expiryDate
  //       default:
  //         break;
  //     }
  //   }

  //   // is.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  //   console.log("SETTING SORT TO = ", this.dataSource.sort)
  //   console.log("SETTING paginator TO = ", this.dataSource.paginator)

  // }

}
